// extracted by mini-css-extract-plugin
export default {"fee":"fee_fee__AbmMF","text":"fee_text__w7ufN","red":"fee_red__ZQP5U","info":"fee_info__zCFwJ","total":"fee_total__t6GOJ"};